"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));

var Tab_1 = __importDefault(require("@material-ui/core/Tab"));

var global_state_1 = require("../../redux/global/global.state");

var StyledTabs = styles_1.withStyles({
  root: {
    padding: '0 3rem',
    backgroundColor: '#fff'
  },
  indicator: {
    backgroundColor: 'var(--color-primary)'
  }
})(Tabs_1.default);
var StyledTab = styles_1.withStyles(function (theme) {
  return styles_1.createStyles({
    root: {
      minWidth: '10rem',
      padding: '2rem',
      fontSize: 'var(--font-size-medium)',
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
      '&:hover': {
        color: 'var(--color-primary)',
        opacity: 1
      },
      '&$selected': {
        color: 'var(--color-primary)',
        fontWeight: theme.typography.fontWeightMedium
      },
      '&:focus': {
        color: 'var(--color-primary)'
      }
    },
    selected: {}
  });
})(function (props) {
  return react_1.default.createElement(Tab_1.default, Object.assign({
    disableRipple: true
  }, props));
});

var TopNavigation = function TopNavigation(_ref) {
  var appMode = _ref.appMode,
      setAppMode = _ref.setAppMode;

  var handleChange = function handleChange(_, newValue) {
    setAppMode(newValue);
  };

  return react_1.default.createElement(StyledTabs, {
    value: appMode,
    onChange: handleChange,
    "aria-label": "ant example"
  }, react_1.default.createElement(StyledTab, {
    label: "\u30B7\u30CA\u30EA\u30AA\u7DE8\u96C6",
    value: global_state_1.AppMode.Editor
  }), react_1.default.createElement(StyledTab, {
    label: "\u5168\u4F53\u8868\u793A",
    value: global_state_1.AppMode.Overview
  }));
};

exports.default = TopNavigation;